/**
 * @generated SignedSource<<49ab4f80c919f2f5b86655cda1dbad67>>
 * @relayHash 1c8ac94ede929f0f77ad21d109eb7507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a5cc0c37f13656f02bff93b2a45aa23b47e5daff5cf08133d1fdf29e5d29560

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiFieldsPageQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type uiFieldsPageQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isExplicitFieldAssociationsEnabled: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"pageHeader_projectFields_Header">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"fieldsTable_projectFields">;
};
export type uiFieldsPageQuery = {
  response: uiFieldsPageQuery$data;
  variables: uiFieldsPageQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider": isProjectFieldsGaFastFollowsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isProjectFieldsGaFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-project-fields-ga-fast-follows-gate-enabled.relayprovider';
import isNumberFieldConfigurationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-ui-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "isExplicitFieldAssociationsEnabled"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "key"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiFieldsPageQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "fieldsTable_projectFields"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "pageHeader_projectFields_Header"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "uiFieldsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "optionsPerFieldLimit"
              },
              {
                "concreteType": "JiraFieldTypeGroupConnection",
                "kind": "LinkedField",
                "name": "projectFieldTypeGroups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldTypeGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldTypeGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                  },
                                  (v8/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "scope"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "hasMissingConfiguration"
                              },
                              {
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v8/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canRemove"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDelete"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canAssociateInSettings"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canEdit"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canModifyOptions"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldOptionConnection",
                                "kind": "LinkedField",
                                "name": "fieldOptions",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraFieldOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "optionId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "parentOptionId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "value"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isFieldLocked"
                              },
                              (v11/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "fieldFormatConfig",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatStyle"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatUnit"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "formatDecimals"
                                          }
                                        ],
                                        "type": "JiraNumberFieldFormatConfig"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v10/*: any*/),
                    "filters": [
                      "input"
                    ],
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v8/*: any*/),
              (v4/*: any*/),
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "projectScopedFieldsPerProjectLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectScopedFieldsCount"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4a5cc0c37f13656f02bff93b2a45aa23b47e5daff5cf08133d1fdf29e5d29560",
    "metadata": {},
    "name": "uiFieldsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider": isProjectFieldsGaFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": isNumberFieldConfigurationEnabled_provider
    }
  }
};
})();

(node as any).hash = "b0872e3059548632993c06522c7f5584";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
